/**
 * Basically provides endpoint URL depending on the environment
 */
export class EndPointProvider {
  static getBaseURLWithoutEndSlash() {
    return process.env.REACT_APP_API_URL;
  }
}
